// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"788edd6d","344":"e99193f7","403":"9271e699","644":"1adcd851","748":"fa16a074","944":"541470ab"}[chunkId] + ".chunk.js";
};